import { setLocalePath } from "@/locales/index";
export const locale_file_path = "views.request_map.";
/**
 * 언어팩 경로 셋팅 메서드
 * @param appendPath 추가로 붙일 경로 문자열
 * @returns
 */
export const autoLc = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default {
    list: {
        page_title: "세부지명 요청",
        create: "요청 등록",
        description: "지역데이터의 세부지명을 추가/수정 요청합니다.",
        table: {
            id: "아이디",
            operation_type: "요청 구분",
            address: "주소",
            result: "결과",
            created_by: "요청자",
            created_time: "등록일",
        },
        cancel_request: "요청취소",
        cancel_request_body: "요청을 취소하시겠습니까?",
        completed: "완료",
        already: "중복",
        operation_type: {
            create: "추가",
            update: "수정",
        },
        operation_detail_type: {
            place_name: "지명",
            administrative_area: "행정동",
            zero_lot_number: "0번지",
        },
    },
    detail: {
        page_title: "상세보기",
    },
};
